var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLnIconB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0886 25.6709C19.9886 25.6709 25.5823 20.0773 25.5823 13.1772C25.5823 6.27717 19.9886 0.683563 13.0886 0.683563C6.18852 0.683563 0.59491 6.27717 0.59491 13.1772C0.59491 20.0773 6.18852 25.6709 13.0886 25.6709Z",
    stroke: "#0C4B76",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43935 11.0433H9.75851V19.1258H7.43935V11.0433ZM8.53981 10.0323H8.52302C7.68351 10.0323 7.13922 9.41441 7.13922 8.63198C7.13922 7.83355 7.6996 7.22787 8.5559 7.22787C9.41151 7.22787 9.93761 7.83202 9.9544 8.62969C9.9544 9.41212 9.41151 10.0323 8.53981 10.0323ZM19.038 19.1266H16.4082V14.9432C16.4082 13.8484 15.9968 13.1018 15.0922 13.1018C14.4003 13.1018 14.0156 13.6054 13.8365 14.0922C13.7693 14.2659 13.7798 14.509 13.7798 14.7528V19.1266H11.1745C11.1745 19.1266 11.2081 11.7167 11.1745 11.0433H13.7798V12.3118C13.9337 11.7571 14.7662 10.9656 16.0948 10.9656C17.743 10.9656 19.038 12.1289 19.038 14.6316V19.1266Z",
    fill: "#0C4B76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1772,
    height: 26.1772,
    fill: "white",
    transform: "translate(0 0.088623)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnIconB);
export default __webpack_public_path__ + "static/media/ln-icon-b.f39e1b9a96c18f87c05992bf76446576.svg";
export { ForwardRef as ReactComponent };